import React from 'react';

export function StatusBadge({ status }) {
  const statusStyles = {
    pending: 'bg-amber-100 text-amber-800 border-amber-400',
    assigned: 'bg-blue-100 text-blue-800 border-blue-400',
    on_the_way: 'bg-violet-100 text-violet-800 border-violet-400',
    completed: 'bg-emerald-100 text-emerald-800 border-emerald-400'
  };

  const labels = {
    pending: 'Pending',
    assigned: 'Assigned',
    on_the_way: 'On The Way',
    completed: 'Completed'
  };

  return (
    <span 
      className={`inline-flex px-3 py-1 text-xs font-bold uppercase tracking-wider border ${statusStyles[status] || statusStyles.pending}`}
      data-testid={`status-badge-${status}`}
    >
      {labels[status] || status}
    </span>
  );
}
